import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import queryString from 'query-string';

Snappy.Component.ContentLoader = class ContentLoader extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-content-loader';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.addEventListeners();
        this.selectFilterOption();
    }

    setVars() {
        this.$contentContainer = this.$element.find('.js-content-container');
        this.$contentFilter = this.$element.find('.js-content-filter');
        this.$contentFilterBtn = this.$element.find('.js-content-filter-btn');
        this.$preloader = this.$element.find('.js-cfa-preloader');
        this.$handler = this.$element.data('url');
        this.$queryParameter = this.$element.data('query-parameter');
        this.$pages = this.$element.find('.js-content-page');
        this.$prevNextPage = this.$element.find('.js-content-page-prev-next');
        this.paramsObj = {};
        this.selectedValue = '';
        this.isLoading = false;
        this.browserAddressWay = this.$element.data('browser-address');
        this.currentPage = 1;
        if (this.$contentFilter.length) {
            this.selectedOption = $(
                this.$contentFilter[0].options[this.$contentFilter[0].selectedIndex]
            );
        }

        this.shouldFocused = false;
    }

    addEventListeners() {
        if (this.$contentFilter.length) {
            this.$contentFilter.on('change', this.onFilterChange.bind(this));
        }
        this.bindPageListeners();

        if (this.$contentFilterBtn) {
            this.$contentFilterBtn.on('click', this.onFilterChange.bind(this));
        }

        this.$window.on('contentLoader:loadByQueryString', this.loadByQueryString.bind(this));
        this.$window.on('contentLoader:setQueryString', this.setQueryString.bind(this));
        this.$window.on('popstate', this.onPopstate.bind(this));
    }

    bindPageListeners() {
        this.unbindPageListeners();
        this.$pages.on('click', (this.bindedPageListeners = this.changePage.bind(this)));
        this.$prevNextPage.on(
            'click',
            (this.bindedPrevNextPageListeners = this.onPrevNextClick.bind(this))
        );
    }

    unbindPageListeners() {
        this.$pages.off('click', this.bindedPageListeners);
        this.$prevNextPage.off('click', this.bindedPrevNextPageListeners);
    }

    onFilterChange() {
        this.$preloader.attr('aria-busy', true);
        this.sendChosenFilter();
    }

    changePage(e) {
        e.preventDefault();
        let page = $(e.target).data('page-number');

        this.shouldFocused = true;
        this.onPageChange(page);
    }

    onPrevNextClick(e) {
        e.preventDefault();

        let link = $(e.currentTarget),
            linkType,
            page;

        linkType = link.data('page-type');

        this.currentPage = this.$pages.filter('.is-active').data('page-number');

        page = linkType === 'prev' ? --this.currentPage : ++this.currentPage;

        this.shouldFocused = true;
        this.onPageChange(page);
    }

    updatePageInParamsObj(page) {
        if (page !== '' && page !== 1) {
            this.paramsObj.page = page;
        }

        if (page === 1) {
            delete this.paramsObj.page;
        }
    }

    onPageChange(page) {

        this.updatePageInParamsObj(page);

        this.isPageChanged = true;
        this.updateBrowserAddress();
        this.fetchData();
    }

    sendChosenFilter() {
        this.paramsObj = {};
        this.currentPage = 1;

        this.selectedOption = $(
            this.$contentFilter[0].options[this.$contentFilter[0].selectedIndex]
        );
        this.selectedValue = this.selectedOption.val();

        if (this.selectedValue !== 'null' && this.selectedValue !== '') {
            this.paramsObj[this.$queryParameter] = this.selectedValue;
        }
        this.updateBrowserAddress();

        this.fetchData();
    }

    setParamsObj(obj) {
        this.paramsObj = obj;
    }

    fetchData() {
        const paramsStr = queryString.stringify(this.paramsObj);
        const url = this.$handler + (this.$handler.indexOf('?') === -1 ? '?' : '&') + paramsStr;

        this.isLoading = true;
        this.toggleLoading();

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'html',
            success: this.handleSuccess.bind(this),
            error: this.handleError.bind(this)
        });
    }

    loadByQueryString(e, qs) {
        const parsedQs = queryString.parse(qs);
        this.setParamsObj(parsedQs);
        this.fetchData();
        this.updateBrowserAddress();
    }
    setQueryString(e, qs) {
        const parsedQs = queryString.parse(qs)
        this.setParamsObj(parsedQs);
    }

    handleSuccess(response) {
        this.isLoading = false;
        this.toggleLoading();
        this.$contentContainer.empty().html(response);
        this.$window.trigger('content:updated');
        this.$pages = this.$contentContainer.find('.js-content-page');
        this.$prevNextPage = this.$contentContainer.find('.js-content-page-prev-next');
        this.bindPageListeners();

        if (this.shouldFocused) {
            this.shouldFocused = false;

            const $card = this.$contentContainer.find('a').first();

            if ($card.length) {
                $card.focus();
            }
        }

        this.$preloader.attr('aria-busy', false);
    }

    handleError(response) {
        console.log(response);
    }

    toggleLoading() {
        this.$preloader.toggleClass('cfa-preloader--active', this.isLoading);
    }

    selectFilterOption() {
        if (!this.selectedOption)
            return;

        let optionType = this.selectedOption.data('type');

        if (optionType) {
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }

            window.scroll(0, this.$element.offset().top - 70);
        }
    }

    updateURLHash() {
        const parsedSearchString = queryString.parse(location.search);

        if (this.$contentFilter.length) {
            const optionType = this.selectedOption.data('type');

            if (optionType) {
                parsedSearchString[this.$queryParameter] = optionType;
            } else {
                delete parsedSearchString[this.$queryParameter];
            }
        }

        if (this.paramsObj.page) {
            parsedSearchString.page = this.paramsObj.page;
        } else {
            delete parsedSearchString.page;
        }

        let URL = location.pathname,
            convertedQuiery = queryString.stringify(parsedSearchString);

        if (convertedQuiery) {
            URL += '?' + convertedQuiery;
        }

        URL += location.hash;

        this.changeHistory(document.title, URL);

    }

    updateBrowserAddress() {
        if (this.browserAddressWay === 'transmit') {
            this.transmitQsObjectToBA();
        } else {
            this.updateURLHash();
        }
    }

    // use query parameters from this.paramsObj (it is used for ajax call) to generate query string in browser address
    transmitQsObjectToBA() {
        const qs = queryString.stringify(this.paramsObj);
        const browserQs = qs ? `?${qs}` : '';
        const url = `${window.location.pathname}${browserQs}`;
        this.changeHistory(document.title, url);
    }

    changeHistory(title, url) {
        if (this.isPageChanged) {
            window.history.pushState({}, title, url);
        } else {
            window.history.replaceState({}, title, url);
        }

        this.isPageChanged = false;
    }

    onPopstate() {
        if (window.location.hash) {
            return;
        }
        const qs = document.location.search;
        const parsedQs = queryString.parse(qs);

        const page = parsedQs.page || 1;
        this.updatePageInParamsObj(page);
        this.fetchData();

    }

};



// WEBPACK FOOTER //
// ./components/content-loader/scripts/contentLoader.js